import { useContext } from 'react';

import { invariant } from '@e-socna/utils';

import { QuotationContext } from '../index';

export const useQuotationContext = () => {
  const context = useContext(QuotationContext);

  invariant(
    !!context,
    'useQuotationContext must be used within a QuotationContextProvider',
  );

  return context;
};
